import { useState } from 'react'

export function useAiAskBarUiState() {
  const [composerPlainText, setComposerPlainText] = useState('')
  const [attachments, setAttachments] = useState([])
  const [isDictating, setIsDictating] = useState(false)
  const [isSendPulsing, setIsSendPulsing] = useState(false)
  const [connectionsOpen, setConnectionsOpen] = useState(false)
  const [documentsPickerOpen, setDocumentsPickerOpen] = useState(false)
  const [attachmentGalleryOpen, setAttachmentGalleryOpen] = useState(false)
  const [attachmentGalleryInitialIndex, setAttachmentGalleryInitialIndex] = useState(0)
  const [attachmentGallerySession, setAttachmentGallerySession] = useState(0)

  return {
    composerPlainText,
    setComposerPlainText,
    attachments,
    setAttachments,
    isDictating,
    setIsDictating,
    isSendPulsing,
    setIsSendPulsing,
    connectionsOpen,
    setConnectionsOpen,
    documentsPickerOpen,
    setDocumentsPickerOpen,
    attachmentGalleryOpen,
    setAttachmentGalleryOpen,
    attachmentGalleryInitialIndex,
    setAttachmentGalleryInitialIndex,
    attachmentGallerySession,
    setAttachmentGallerySession,
  }
}
